import { useMutation } from '@tanstack/react-query';
import { toast } from '@/hooks/use-toast';
import { useOrganization } from '@/domains/organizations';
import { apifyBrandInfoExtractor } from '../infrastructure/apifyBrandInfoExtractor';
import type { ExtractBrandInfoResult } from '../types/brand.types';

export function useExtractBrandInfo() {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id;

  return useMutation<ExtractBrandInfoResult, Error, string>({
    mutationFn: async (input: string) => {
      if (!orgId) {
        throw new Error('No organization selected');
      }
      return apifyBrandInfoExtractor.extractBrandInfo(orgId, input);
    },
    onError: (error) => {
      toast({
        title: 'Could not fetch brand details',
        description: error.message || 'Could not fetch brand details. Please try again.',
        variant: 'destructive',
      });
    },
  });
}
